<template>
    <button
        class="btn btn-outline-custom"
        :class="{ 'btn-sm': !editMode }"
        @click="deleteStoreUser"
    >
        <a-icon icon="Bin" :height="`${editMode ? '21px' : '24px'}`" />
        <span class="ml-1"> Usuń</span>
    </button>
</template>

<script>
export default {
    name: 'StoreUsersDeleteBtn',
    props: {
        login: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        deleteStoreUser() {
            this.$store.dispatch('openModal', {
                component: 'DeleteStoreUser',
                args: {
                    login: this.login,
                    id: this.id
                }
            })
        }
    }
}
</script>
